export default __webpack_public_path__ + "static/media/IMG_5063.a80abe00.png";